import { useMemo } from 'react';

import type { IPlanBenefits } from '../../interfaces/clients';
import { categorizePlanAddons } from '../../utils/clients/clientPlans';
import { flattenAddonCatalog } from '../../utils/quotes/quotes';
import { useBroker } from '../useBroker/useBroker';

export interface IUsePlanBenefits extends IPlanBenefits {
  loading: boolean;
}

export const usePlanBenefits = (addonIds: number[]): IUsePlanBenefits => {
  const { commercialAddons, loadingAddons } = useBroker();

  const benefits = useMemo(
    () => categorizePlanAddons(addonIds, flattenAddonCatalog(commercialAddons)),
    [addonIds, commercialAddons]
  );

  return { ...benefits, loading: loadingAddons };
};
